import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { BenefitChangeRequest } from '@models/benefits/benefit-change-request.model';

@Component({
    selector: 'app-form-benefit-change-request-approval',
    templateUrl: './benefit-change-request-approval.template.html',
})
export class BenefitChangeRequestApproval extends BaseForm {
    @Input() changeRequest: BenefitChangeRequest;
    @Output() changeRequestChange = new EventEmitter();
}
